/**************************************************
 * Nombre:       Formulario_Formacion
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {AccountCircleOutlined, ApartmentOutlined, PhoneAndroidOutlined, WorkspacePremium,BadgeOutlined} from "@mui/icons-material";
import {NEGRITA} from "../../Constantes";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import {obtenerFormaciones} from "../../CodNegocio/Funciones/obtenerFormaciones";
import {useEffect, useState} from "react";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";

const Formulario_Formacion = ({...props}) => {
    const {sCell} = useResponsive()
    const [formaciones, setFormaciones] = useState([]);

    useEffect(() =>{

        let val = props.props.getValues('escuela');
        if (val){
            setFormaciones(obtenerFormaciones(val));
        }else{
            setFormaciones([]);
        }

    },props.props.watch('escuela'))
    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mb: 0}}>
                    <Typography sx={{fontSize: sCell ? 32 : 38, fontFamily: NEGRITA, fontWeight: 600, lineHeight: 1.1}}>
                        Area de Formacion
                    </Typography>
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mb: 2}}>
                    <Typography sx={{fontSize: 16, fontWeight: 400}}>
                        Escoge el area de formacion al que desees inscribirte, si no encuentras alguno de tu agrado da
                        click en el boton atras y revisa en otra Escuela de aperndizaje
                    </Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoSelect Icono={WorkspacePremium} nombre={'Escuela de aprendizaje (Area de conocimiento)'}
                                   dato={'formacion'} {...props} lineas={3}
                                   opciones={formaciones}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 6}}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Nombres'} dato={'nombres'} {...props}

                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 6}}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Apellidos'} dato={'apellidos'} {...props}

                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 6}}>
                    <IngresoTexto Icono={BadgeOutlined} nombre={'Num Id'} dato={'cc'} {...props}

                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 6}}>
                    <IngresoTexto Icono={PhoneAndroidOutlined} nombre={'Celular'} dato={'celular'} {...props}

                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={ApartmentOutlined} nombre={'Correo'} dato={'correo'} {...props}

                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Formacion